import React, { useState } from 'react';
import { Space, Popover } from 'antd';
import ToggleIcon from '@icons/common/toggle.svg';
import AdminControls from './components/AdminControls';
import Panels from './components/Panels';
import { SectionWrapper, MainSection, StyledDivider } from './styled';
import { ToggleButton } from '@src/components/common/Utils/Buttons';
import Actions from './components/Actions';
import { isAppModule } from '@src/utils/constants';
import { checkIsAdminUser, checkIsInternalUser } from '@src/globalStore/profileStore';

const Content = () => {
  const isAdmin = checkIsAdminUser();
  const isInternal = checkIsInternalUser();
  const enableAdminAction = isAdmin && isInternal && isAppModule;
  return (
    <MainSection>
      <SectionWrapper>
        <div>
          <Panels />
        </div>
        <StyledDivider type="vertical" />
        <div>
          <Actions />
        </div>
        {enableAdminAction && (
          <>
            <StyledDivider type="vertical" />
            <div>
              <AdminControls />
            </div>
          </>
        )}
      </SectionWrapper>
    </MainSection>
  );
};

function OptionsPopover() {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return (
    <Space wrap style={{ margin: 5 }}>
      <Popover
        content={<Content />}
        title=""
        trigger="click"
        placement="bottomRight"
        styles={{ body: { paddingLeft: 20 } }}
        zIndex={900}
        getPopupContainer={(trigger) => (trigger.parentNode as HTMLElement) || document.body}
        open={open}
        onOpenChange={handleOpenChange}
      >
        <ToggleButton icon={<ToggleIcon />} />
      </Popover>
    </Space>
  );
}

export default OptionsPopover;
